import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParticipanteReuniao } from 'src/app/core/participante-reuniao';
import { Rotas } from 'src/app/core/rotas';
import { BaseService } from '../base/base.service';


@Injectable({
  providedIn: 'root'
})
export class ParticipanteReuniaoService extends BaseService<ParticipanteReuniao> {
  
  constructor(http: HttpClient) {
    super(http, Rotas.REUNIOES);
  }

  getAllParticipantesCombo() {
    return this.http.get(`${Rotas.REUNIOES}participantes/combo`);
  }

  getParticipanteById(id: number) {
    return this.http.get(Rotas.REUNIOES + 'participantes/' + id);
  }

}

